import './TpfSlider.css';
import Info from '../Info'

const TpfSlider = ({ title, minValue="0", maxValue, valor, setValor, stepType, description }) => {

  const handleChange = (event) => {
    setValor(event.target.value);
  };

  const progress = ((valor - minValue) / (maxValue - minValue)) * 100;

  return (
    <div className="tpf-slider">
      <div className="slider-header">
          <span className="slider-title">{title}</span>
          <Info description={description} />
      </div>
      <input
        data-testid="tpf-slider"
        type="range"
        min={minValue}
        max={maxValue}
        step={stepType === "int" ? 1 : 0.01} // Define o step de acordo com a prop
        value={valor}
        onChange={handleChange}
        className="slider"
        style={{ '--progress-percentage': `${progress}%`}}
      />
      <span className="slider-value">{valor}</span>
    </div>
  );
};

export default TpfSlider;
